import { io, Socket } from 'socket.io-client';

class WebSocketService {
  private socket: Socket | null = null;
  private isConnected = false;

  connect(token: string, userId: number) {
    if (this.socket) {
      this.disconnect();
    }

    // Preferir URL específica de WS, caindo para API e removendo /api se presente
    const rawWs = process.env.REACT_APP_WS_URL || process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const serverUrl = rawWs.replace(/\/api\/?$/, '');


    // Limpar qualquer cache do Socket.IO
    if (typeof window !== 'undefined') {
      // Limpar localStorage do Socket.IO
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('socket.io')) {
          localStorage.removeItem(key);
        }
      });

      // Limpar sessionStorage do Socket.IO
      Object.keys(sessionStorage).forEach(key => {
        if (key.startsWith('socket.io')) {
          sessionStorage.removeItem(key);
        }
      });
    }
    
    this.socket = io(serverUrl, {
      path: '/socket.io',
      withCredentials: true,
      forceNew: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 10000,
      transports: ['polling', 'websocket'],
      upgrade: true,
      rememberUpgrade: false,
      autoConnect: true,
      // Força uma nova conexão sem reutilizar session
      query: {
        timestamp: Date.now().toString()
      }
    });
    

    this.socket.on('connect', () => {
      this.isConnected = true;

      // Autenticar usuário
      this.socket?.emit('authenticate', { token, userId });
    });

    // Listener para confirmação de autenticação
    this.socket.on('authenticated', (data) => {
      // Authentication confirmed
    });

    this.socket.on('disconnect', (reason) => {
      this.isConnected = false;
    });

    this.socket.on('connect_error', (error) => {
      // Silenciar erros de conexão quando o backend está indisponível
      if (error.message.includes('xhr poll error') || error.message.includes('ERR_FAILED')) {
        // Silenciar completamente para manter console limpo
        return;
      } else {
        console.error('❌ [WEBSOCKET] Erro de conexão:', error.message);
      }
    });

    this.socket.on('error', (error) => {
      // Silenciar erros comuns quando backend está fora
      if (error.message?.includes('ERR_FAILED') || error.message?.includes('NetworkError')) {
        // Silenciar completamente para manter console limpo
        return;
      } else {
        console.error('❌ [WEBSOCKET] Erro geral:', error);
      }
    });

    this.socket.on('reconnect', (attemptNumber) => {
      // Re-autenticar após reconexão bem-sucedida
      if (this.socket) {
        this.socket.emit('authenticate', { token, userId });
      }
    });

    // Listener para confirmação de pagamento
    this.socket.on('payment_confirmed', (data) => {
      // Mostrar notificação
      if ('Notification' in window && Notification.permission === 'granted') {
        new Notification('Pagamento Confirmado!', {
          body: data.message || 'Seu pagamento foi confirmado com sucesso!',
          icon: '/favicon.ico'
        });
      }

      // Disparar evento customizado para componentes React
      const customEvent = new CustomEvent('payment_confirmed', { detail: data });
      window.dispatchEvent(customEvent);
    });

    // Additional event handling can be added here if needed

    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  // Método para forçar reconexão limpa
  forceReconnect(token: string, userId: number) {
    this.disconnect();

    // Aguardar um pouco antes de reconectar
    setTimeout(() => {
      this.connect(token, userId);
    }, 1000);
  }

  isSocketConnected() {
    return this.isConnected;
  }

  // Método para solicitar permissão de notificação
  requestNotificationPermission() {
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }

}

export const websocketService = new WebSocketService();